const isPlainObject = (value) => {
	if (typeof value !== "object" || value === null) {
		return false;
	}

	const prototype = Object.getPrototypeOf(value);
	return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
};


const areObjectsTheSame = (a, b, level, maxLevel) => {
	const aKeys = Object.keys(a);

	return aKeys.length === Object.keys(b).length
		&& aKeys.reduce((res, key) => {
			if (res) {
				res = Object.is(a[key], b[key]);
				if (!res && (level < maxLevel) && isPlainObject(a[key])) {
					res = areObjectsTheSame(a[key], b[key], (level + 1), maxLevel);
				}
			}

			return res;
		}, true);
};

const getDeepCompare = (maxLevel) => (a, b) => {
	return Object.is(a, b) ||
		areObjectsTheSame(a, b, 0, maxLevel);
};

export default getDeepCompare;
